function fileChange(input) {

	var filename;
        var trimText;

	if ($(input).val() != '') {

		filename = $(input).val().split('\\');

                trimText = (filename[filename.length - 1].length > 12) ? filename[filename.length - 1].substring(0, 12)+ '...' : filename[filename.length - 1];

		$('.icn-download span').html(trimText);
	} else {

		$('.icn-download span').html('Joindre votre CV');
	}
}

$(function () {

	fix_image();

	var container = $("#offers");
	var form = $("#offersForm");
	var type_select = $(".customSelect", form);
    var from_select = false;

	$("select", type_select).on("change", function () {
        $('.btn_toggle').html('<span>Voir le détail</span>');
        var id_job = $(this).val();
        from_select = true;
        $('article[data-job='+id_job+']').find('.btn_toggle').trigger( "click" );
		type_select.attr("data-val", this.value);
	});

	container.on("click", ".btn_apply", function (evt) {
		var job = $(this).parents('.offer').data("job");

		evt.preventDefault();

        container.find('.btn_toggle').html('<span>Voir le détail</span>');
        $('.detail_dropdown').hide();
        form.find('input:first').focus();
        type_select.attr("data-val", job);
        $("select", type_select).val(job);
        if($(window).width() < 1280) {
            $('html, body').animate({scrollTop:$('#offersForm').position().top - 70}, 'slow');
        }
	});


    var boxInitialTop = $('#offersForm').offset().top;

    var url = String(window.location);
    var current_elem;
    if(url.indexOf("paris") > 1){
        if(url.indexOf("developpeur-front") > 1) {
            current_elem = 'webcontr';
            $('.offer[data-job="webcontr"] .detail_dropdown').css('display','block');
            $('.offer[data-job="webcontr"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('webcontr');
        } else if(url.indexOf("developpeur-back") > 1) {
            current_elem = 'webdev';
            $('.offer[data-job="webdev"] .detail_dropdown').css('display','block');
            $('.offer[data-job="webdev"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('webdev');
        }else if(url.indexOf("business-developer") > 1) {
            current_elem = 'web_dev_bus';
            $('.offer[data-job="web_dev_bus"] .detail_dropdown').css('display','block');
            $('.offer[data-job="web_dev_bus"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('web_dev_bus');
        }else if(url.indexOf("community-manager") > 1) {
            current_elem = 'web_com_manager';
            $('.offer[data-job="web_com_manager"] .detail_dropdown').css('display','block');
            $('.offer[data-job="web_com_manager"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('web_com_manager');
        }else if(url.indexOf("chef-de-projet") > 1) {
            current_elem = 'web_cdp';
            $('.offer[data-job="web_cdp"] .detail_dropdown').css('display','block');
            $('.offer[data-job="web_cdp"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('web_cdp');
        }else if(url.indexOf("graphiste-webdesigner") > 1) {
            current_elem = 'webgraph';
            $('.offer[data-job="webgraph"] .detail_dropdown').css('display','block');
            $('.offer[data-job="webgraph"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('webgraph');
        } else if(url.indexOf("data-analyst") > 1) {
            current_elem = 'data_analyst';
            $('.offer[data-job="data_analyst"] .detail_dropdown').css('display','block');
            $('.offer[data-job="data_analyst"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('data_analyst');
        } else if(url.indexOf("traffic-manager") > 1) {
            current_elem = 'traffic';
            $('.offer[data-job="traffic"] .detail_dropdown').css('display','block');
            $('.offer[data-job="traffic"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('traffic');
        } else if(url.indexOf("administrateur-reseaux") > 1) {
            current_elem = 'administrateur';
            $('.offer[data-job="administrateur"] .detail_dropdown').css('display','block');
            $('.offer[data-job="administrateur"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('administrateur');
        }
    }else{
        if(url.indexOf("developpeur-front") > 1) {
            current_elem = 'webdev';
            $('.offer[data-job="webdev"] .detail_dropdown').css('display','block');
            $('.offer[data-job="webdev"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('webdev');
        } else if(url.indexOf("controleur-qualite") > 1) {
            current_elem = 'webcontr';
            $('.offer[data-job="webcontr"] .detail_dropdown').css('display','block');
            $('.offer[data-job="webcontr"]').find('.btn.ter.btn_toggle').html('<span>Fermer le détail</span>');
            $("select", type_select).val('webcontr');
        }
    }

    if (current_elem != '') {
        var paddingTop = $('.offer[data-job="'+current_elem+'"]').css("paddingTop").replace('px','');
        $('html, body').animate({
            scrollTop: ($('.offer[data-job="'+current_elem+'"]').offset().top-paddingTop)
        },500);

    }
});

$('.country_zone').click(function(){
    window.location.href = $('a',this).attr('href');
});

$('.country_zone').hover(function(){
    var img = $(this).find(".img_locator");
    var text = $(this).find("a");
    var textColor = $(this).find("span");

    if($(window).width() > 736) {
        img.animate({
          height:'7%'
        },200);
        text.animate({
          fontSize:'1.6vw'
        },200);
        textColor.css('color','#0191ff');
    }
}, function() {
    var img = $(this).find(".img_locator");
    var text = $(this).find("a");
    var textColor = $(this).find("span");

    if($(window).width() > 736) {
        img.animate({
           height:'6%'
         },200);
         text.animate({
          fontSize:'1.5vw'
        },200);
        textColor.css('color','#000000');
    }
});

$('.btn_toggle').click(function(){
    var button = $(this);
    var object = $(this).parent().next('.detail_dropdown');
    var job = $(this).parents('.offer').data("job");
    var form = $("#offersForm");
    var type_select = $(".customSelect", form);
    var url = String(window.location);

    if(url.indexOf("?") > 0){
        url = url.split("?");
        url = url[0];
    }

    $( "#add_crumb" ).remove();
    if(url.indexOf('paris') > 0){
        var clean_url = url.replace("paris.html", "").replace("paris/developpeur-front.html", "").replace("paris/developpeur-back.html", "").replace("paris/business-developer.html", "").replace("paris/community-manager.html", "").replace("paris/chef-de-projet.html", "").replace("paris/developpeur-php-symfony.html", "").replace("paris/graphiste-webdesigner.html", "").replace("paris/data-analyst.html", "").replace("paris/traffic-manager.html", "").replace("paris/administrateur-reseaux.html", "");
    }else{
        var clean_url = url.replace("maurice.html", "").replace("maurice/developpeur-front.html", "").replace("maurice/controleur-qualite.html", "");
    }

    if(job === 'webdev'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span> Développeur back-end</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/developpeur-back.html");
        }else{
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span> Développeur front-end</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"maurice/developpeur-front.html");
        }
    }else if(job === 'webcontr'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span> Développeur font-end </span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/developpeur-front.html");
        }else{
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span> Contrôleur qualité web </span></div>');
            window.history.pushState("object or string", "Title", clean_url+"maurice/controleur-qualite.html");
        }
    }else if(job === 'web_dev_bus'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span>business developer</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/business-developer.html");
        }
    }else if(job === 'web_com_manager'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span>community manager</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/community-manager.html");
        }
    }else if(job === 'web_cdp'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span>Chef de projet</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/chef-de-projet.html");
        }
    }else if(job === 'web_php'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span> Développeur PHP/Symfony </span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/developpeur-php-symfony.html");
        }
    }else if(job === 'webgraph'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span> Graphiste - Webdesigner </span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/graphiste-webdesigner.html");
        }
    } else if(job === 'data_analyst'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span>Data Analyst</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/data-analyst.html");
        }
    } else if(job === 'traffic'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span>Traffic manager</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/traffic-manager.html");
        }
    } else if(job === 'administrateur'){
        if(url.indexOf('paris') > 0){
            $('.breadcrumbs').append('<div id="add_crumb" class="crumb"><span>Administrateur réseaux</span></div>');
            window.history.pushState("object or string", "Title", clean_url+"paris/administrateur-reseaux.html");
        }
    }

    $('.btn.ter.btn_toggle').html('<span>Voir le détail</span>');
    var no_select = (object.css('display') == 'block');
    object.fadeToggle('slow',function(){
        if(!object.is(':visible'))
        {
            button.html('<span>Voir le détail</span>');
            window.history.pushState("object or string", "Title", clean_url+"maurice.html");
            if(url.indexOf('paris') > 0){
                window.history.pushState("object or string", "Title", clean_url+"paris.html");
            }else{
                window.history.pushState("object or string", "Title", clean_url+"maurice.html");
            }
            $( "#add_crumb" ).remove();
            if( no_select ) {
                $("select", type_select).val('');
            }
        } else {
            $("select", type_select).val(job);
            // On traque lorsqu'un utilisateur visualise une offre
            fbq('track', 'ViewContent', {
                content_name: job,
            });
        }

        $('.btn_toggle').parent().next('.detail_dropdown').not(this).css('display','none');
    });

    button.html('<span>Fermer le détail</span>');
});

$( document ).ready(function() {
	fix_image();
});

window.onscroll = function() {
	fix_image();
};

function fix_image(){
    if($(window).width() > 1280) {
	$(".form_sticky_wrapper").stick_in_parent({inner_scrolling:false,offset_top:98});
    }
}
